import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoLink from 'eco-design/base/eco-link';

const M: React.FC = () => {
    const { t } = useLang('shp3.M');
    const sectionRef = useRef<HTMLDivElement>(null);
    const [enter, setEnter] = useState({});
    const { isPad, isH5 } = useDeviceDetect();
    const [videoLoaded, setVideoLoaded] = useState(false);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current.querySelector('.title');
        const desc = sectionRef.current.querySelector('.desc');
        const btn = sectionRef.current.querySelector('.btn');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
                btn?.classList.add('enter');
            },
            onprogress: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    btn?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            // setIsClient(true);
            const sceneHArr: any[] = [];
            ['btn'].forEach((item: string) => {
                const dom: HTMLElement | null = document.querySelector(`.shp3-M .${item}-ani`);
                if (dom) {
                    sceneHArr.push(
                        AniContainer.create({
                            triggerElement: '#shp3-M .btn-ani',
                            triggerHook: 1,
                            offset: window.innerWidth > 768 ? dom?.offsetHeight + 20 : dom?.offsetHeight,
                            duration: window.innerHeight * 1.2,
                            onEnter: () =>
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: true,
                                })),
                            onLeave: () => {
                                if (window.innerWidth > 768) {
                                    setEnter((p) => ({
                                        ...p,
                                        [item]: false,
                                    }));
                                }
                            },
                        }),
                    );
                }
            });
            return () => {
                sceneHArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);
    // 懒加载视频
    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: '.shp3-J',
            triggerHook: 1,
            onEnter: () => {
                setVideoLoaded(true);
            },
        });
        return () => {
            loader.destroy();
        };
    }, []);
    // 播放视频

    useEffect(() => {
        if (!sectionRef.current) return;
        const playingVideo = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = document.querySelector('#shp3-M video') as HTMLVideoElement;
                    if (entry.isIntersecting) {
                        video.currentTime = 0;
                        video.play();
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        playingVideo.observe(sectionRef.current);
        return () => {
            playingVideo.disconnect();
        };
    }, []);

    return (
        <section
            className={`${css.section} shp3-M GtmModuleData-section`}
            id="shp3-M"
            data-section-id={'shp3-M'}
            data-section-title={t('M_title')}
            ref={sectionRef}
        >
            {/* <EcoImg pc=" /> */}
            {videoLoaded && (
                <EfVideo
                    className="AIDrivenVideo"
                    pc={'https://websiteoss.ecoflow.com/upload/video/1760002206954/SHP3%E4%BD%BF%E7%94%A8_1.mp4'}
                    poster={
                        isPad || isH5
                            ? 'https://websiteoss.ecoflow.com/upload/image/1760170628108/m_7%E5%A4%A9%E8%90%BD%E5%9C%B0(%E8%A7%86%E9%A2%91).jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1760170628636/pc_7%E5%A4%A9%E8%90%BD%E5%9C%B0(%E8%A7%86%E9%A2%91).jpg'
                    }
                    key="pc"
                    loop
                    preload="none"
                />
            )}
            <div className="info">
                <div className="title ani-1">{t('title')}</div>
                <div className="desc ani-2">{t('desc')}</div>
            </div>
            <EcoLink
                className={`btn-ani GtmModuleData-btn-href`}
                href="https://us.ecoflow.com/products/installation-service?variant=54527686869065"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: t('naver_title'),
                    position: t('title'),
                    display_type: 'none',
                    module_referral: 'none',
                    jump_module: 'none',
                    __btn_id1: `${css.section} .btn-ani`,
                    __btn_id2: 'https://us.ecoflow.com/products/installation-service?variant=54527686869065',
                    __btn_type: 'href',
                }}
            >
                <span className={`btn GtmModuleData-btn-href ${enter.btn ? ' enter' : ''}`}>
                    {t('btn')}
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                        <g clipPath="url(#clip0_4622_13229)">
                            <path
                                d="M14 26.0918C20.6274 26.0918 26 20.7192 26 14.0918C26 7.46438 20.6274 2.0918 14 2.0918C7.37258 2.0918 2 7.46438 2 14.0918C2 20.7192 7.37258 26.0918 14 26.0918Z"
                                fill="#3F68E0"
                            />
                            <path
                                d="M12.7178 19.208L17.5004 14.4254L17.588 14.338L12.6963 9.44629"
                                stroke="white"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_4622_13229">
                                <rect width="28" height="28" fill="white" transform="translate(0 0.0917969)" />
                            </clipPath>
                        </defs>
                    </svg>
                </span>
            </EcoLink>
        </section>
    );
};

export default M;
